module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_1@2x.43fdd55a.png";